import {createStyles} from '@material-ui/core';
import {defaultFont} from '../../styles/style';

export const style = createStyles({
  dialogPaper: {
    width: 400,
    position: 'relative',
    textAlign: 'center',
  },
  title: {
    ...defaultFont,
  },
  closeButton: {
    position: 'absolute',
  },
  text: {
    ...defaultFont,
    marginBottom: '8px',
  },
  text_bold: {
    ...defaultFont,
    fontWeight: 'bold',
  },
  dropdown: {
    width: '60%',
    margin: '0 auto',
    textAlign: 'start',
  },
});
